import { FC } from 'react';
import { Button, ButtonStyles, DefaultContentComponent, Popup } from '@silverfort/sf-components';

interface Props {
    open: boolean;
    handleConfirm: VoidFunction;
    handleCancel: VoidFunction;
}

type FooterProps = Pick<Props, 'handleConfirm' | 'handleCancel'>;

const FooterComponent: FC<FooterProps> = ({ handleConfirm, handleCancel }) => {
    return (
        <div className="flex flex-row flex-1 justify-end gap-2">
            <Button text="Cancel" buttonStyle={ButtonStyles.TertiarySolid} onClick={handleCancel} />
            <Button text="Remove" onClick={handleConfirm} />
        </div>
    );
};

const DeleteTokenPopup: FC<Props> = ({ open, handleConfirm, handleCancel }) => {
    return (
        <Popup
            open={open}
            title="Remove token"
            ContentComponent={DefaultContentComponent}
            ContentComponentProps={{
                text: 'Are you sure you want to remove this token?'
            }}
            FooterComponent={FooterComponent}
            FooterComponentProps={{ handleConfirm, handleCancel }}
            onClose={handleCancel}
            popupClassName="w-[360px] h-[160px]"
        />
    );
};

export default DeleteTokenPopup;
